var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.riga
    ? _c(
        "v-card",
        [
          _c("v-card-subtitle", [_c("h2", [_vm._v("Variazioni correlate")])]),
          _c(
            "v-card-text",
            [
              _vm.riga && _vm.riga.righeCorrelate.length > 0
                ? _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    _vm._l(_vm.riga.righeCorrelate, function (rigaCorrelata) {
                      return _c(
                        "v-flex",
                        { key: rigaCorrelata.id, attrs: { xs12: "" } },
                        [
                          _vm.mostraRiga(rigaCorrelata)
                            ? _c("v-col", { staticClass: "col-dati" }, [
                                _c(
                                  "div",
                                  {
                                    class: {
                                      "deleted-field": _vm.isDeleted(
                                        _vm.variazioneDiValidazione
                                      ),
                                    },
                                  },
                                  [
                                    _c("table", [
                                      _c("tr", [
                                        _vm.variazioneDiValidazione
                                          .statoValidazione ==
                                        _vm.StatoVariazione.RigaEliminataDaBC
                                          ? _c(
                                              "td",
                                              [
                                                _c("v-switch", {
                                                  staticStyle: {
                                                    "margin-right": "10px",
                                                    "margin-left": "10px",
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.cambiaStatoVariazione(
                                                        rigaCorrelata
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value:
                                                      _vm
                                                        .variazioneDiValidazione
                                                        .variazioniCorrelate[
                                                        rigaCorrelata.id
                                                      ].mostraCorrelate,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm
                                                          .variazioneDiValidazione
                                                          .variazioniCorrelate[
                                                          rigaCorrelata.id
                                                        ],
                                                        "mostraCorrelate",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "variazioneDiValidazione.variazioniCorrelate[rigaCorrelata.id].mostraCorrelate",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _c(
                                          "td",
                                          [
                                            _c("div", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.descProvenienza(
                                                    rigaCorrelata
                                                  )
                                                ),
                                              },
                                            }),
                                            _vm.variazioneDiValidazione
                                              .statoValidazione !=
                                            _vm.StatoVariazione
                                              .RigaEliminataDaBC
                                              ? _c(
                                                  "v-row",
                                                  [
                                                    _c(
                                                      "v-col",
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              "margin-top":
                                                                "10px",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                rigaCorrelata
                                                                  .innerRigaDistinta
                                                                  .descri
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "variazione-container",
                                                          },
                                                          [
                                                            _c(
                                                              "ul",
                                                              _vm._l(
                                                                rigaCorrelata.quantitaPerTaglia,
                                                                function (
                                                                  qta,
                                                                  index
                                                                ) {
                                                                  return _c(
                                                                    "li",
                                                                    {
                                                                      key:
                                                                        "li_" +
                                                                        index,
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              qta.desc
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          (+qta.qta)
                                                                            .toFixed(
                                                                              2
                                                                            )
                                                                            .replace(
                                                                              ".",
                                                                              ","
                                                                            )
                                                                        ) + " "
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._l(
                                                          _vm.variazioniDaProcessare(
                                                            rigaCorrelata
                                                          ),
                                                          function (
                                                            variazione,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "div",
                                                              {
                                                                key:
                                                                  "var_" +
                                                                  index,
                                                                staticClass:
                                                                  "variazione-container variazione-modifiche",
                                                              },
                                                              [
                                                                _c("div", [
                                                                  _vm._v(
                                                                    " Comunicazione #" +
                                                                      _vm._s(
                                                                        variazione.indice
                                                                      ) +
                                                                      " del " +
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "formatDate"
                                                                        )(
                                                                          variazione.dataComunicazione
                                                                        )
                                                                      ) +
                                                                      " da fornitore: " +
                                                                      _vm._s(
                                                                        variazione.idFornitore
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]),
                                                                variazione.statoValidazione ==
                                                                _vm
                                                                  .StatoVariazione
                                                                  .RigaModificataDalFornitore
                                                                  ? _c(
                                                                      "ul",
                                                                      _vm._l(
                                                                        rigaCorrelata.quantitaPerTaglia,
                                                                        function (
                                                                          qta,
                                                                          i2
                                                                        ) {
                                                                          return _c(
                                                                            "li",
                                                                            {
                                                                              key:
                                                                                "li_" +
                                                                                variazione.indice +
                                                                                i2,
                                                                              class:
                                                                                {
                                                                                  "red--text":
                                                                                    variazione
                                                                                      .quantitaPerTagliaPreComunicazione[
                                                                                      qta.indice -
                                                                                        1
                                                                                    ] !=
                                                                                    variazione
                                                                                      .quantitaPerTagliaComunicate[
                                                                                      qta.indice -
                                                                                        1
                                                                                    ],
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    (+variazione
                                                                                      .quantitaPerTagliaComunicate[
                                                                                      qta.indice -
                                                                                        1
                                                                                    ])
                                                                                      .toFixed(
                                                                                        2
                                                                                      )
                                                                                      .replace(
                                                                                        ".",
                                                                                        ","
                                                                                      )
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                            ]
                                                                          )
                                                                        }
                                                                      ),
                                                                      0
                                                                    )
                                                                  : _vm._e(),
                                                                variazione.statoValidazione ==
                                                                _vm
                                                                  .StatoVariazione
                                                                  .RigaModificataDalFornitore
                                                                  ? _c(
                                                                      "v-btn",
                                                                      {
                                                                        staticClass:
                                                                          "row-button",
                                                                        attrs: {
                                                                          color:
                                                                            "primary",
                                                                          fab: "",
                                                                          "x-small":
                                                                            "",
                                                                          dark: "",
                                                                          absolute:
                                                                            "",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.applicaModifica(
                                                                                rigaCorrelata,
                                                                                variazione
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-arrow-down-thick"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    )
                                                                  : variazione.statoValidazione ==
                                                                    _vm
                                                                      .StatoVariazione
                                                                      .RigaEliminataDalFornitore
                                                                  ? [
                                                                      _vm._v(
                                                                        " Richiesta eliminazione riga "
                                                                      ),
                                                                    ]
                                                                  : _vm._e(),
                                                                _vm
                                                                  .variazioneDiValidazione
                                                                  .variazioniCorrelate[
                                                                  rigaCorrelata
                                                                    .id
                                                                ]
                                                                  .statoValidazione ==
                                                                _vm
                                                                  .StatoVariazione
                                                                  .RigaEliminataDalFornitore
                                                                  ? _c(
                                                                      "v-btn",
                                                                      {
                                                                        staticClass:
                                                                          "row-button",
                                                                        attrs: {
                                                                          color:
                                                                            "grey",
                                                                          fab: "",
                                                                          "x-small":
                                                                            "",
                                                                          dark: "",
                                                                          absolute:
                                                                            "",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.applicaCancellazione(
                                                                                rigaCorrelata
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-check"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm
                                                                      .variazioneDiValidazione
                                                                      .variazioniCorrelate[
                                                                      rigaCorrelata
                                                                        .id
                                                                    ]
                                                                      .statoValidazione ==
                                                                    _vm
                                                                      .StatoVariazione
                                                                      .RigaEliminataDaBC
                                                                  ? _c(
                                                                      "v-btn",
                                                                      {
                                                                        staticClass:
                                                                          "row-button",
                                                                        attrs: {
                                                                          color:
                                                                            "orange",
                                                                          fab: "",
                                                                          "x-small":
                                                                            "",
                                                                          dark: "",
                                                                          absolute:
                                                                            "",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.annullaCancellazione(
                                                                                rigaCorrelata
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-undo"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e(),
                                                              ],
                                                              2
                                                            )
                                                          }
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "variazione-container variazione-validazione",
                                                          },
                                                          [
                                                            _vm
                                                              .variazioneDiValidazione
                                                              .variazioniCorrelate[
                                                              rigaCorrelata.id
                                                            ]
                                                              .statoValidazione ==
                                                              _vm
                                                                .StatoVariazione
                                                                .RigaModificataDaBC ||
                                                            _vm
                                                              .variazioneDiValidazione
                                                              .variazioniCorrelate[
                                                              rigaCorrelata.id
                                                            ]
                                                              .statoValidazione ==
                                                              _vm
                                                                .StatoVariazione
                                                                .RigaAggiuntaDaBC ||
                                                            _vm
                                                              .variazioneDiValidazione
                                                              .variazioniCorrelate[
                                                              rigaCorrelata.id
                                                            ]
                                                              .statoValidazione ==
                                                              _vm
                                                                .StatoVariazione
                                                                .RigaModificataDalFornitore ||
                                                            _vm
                                                              .variazioneDiValidazione
                                                              .variazioniCorrelate[
                                                              rigaCorrelata.id
                                                            ]
                                                              .statoValidazione ==
                                                              _vm
                                                                .StatoVariazione
                                                                .RigaAggiuntaDalFornitore
                                                              ? _c(
                                                                  "ul",
                                                                  _vm._l(
                                                                    _vm
                                                                      .variazioneDiValidazione
                                                                      .variazioniCorrelate[
                                                                      rigaCorrelata
                                                                        .id
                                                                    ]
                                                                      .quantitaPerTagliaComunicate,
                                                                    function (
                                                                      qta,
                                                                      i
                                                                    ) {
                                                                      return _c(
                                                                        "li",
                                                                        {
                                                                          key:
                                                                            "sum_" +
                                                                            _vm
                                                                              .riga
                                                                              .innerRigaDistinta
                                                                              .posizRiga +
                                                                            i,
                                                                        },
                                                                        [
                                                                          _vm
                                                                            .variazioneDiValidazione
                                                                            .variazioniCorrelate[
                                                                            rigaCorrelata
                                                                              .id
                                                                          ]
                                                                            ._accettata ||
                                                                          _vm
                                                                            .riga
                                                                            .richiestaDiInserimento
                                                                            ? _c(
                                                                                "div",
                                                                                {
                                                                                  staticStyle:
                                                                                    {
                                                                                      padding:
                                                                                        "10px 0",
                                                                                      "background-color":
                                                                                        "#dffadf !important",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    " " +
                                                                                      _vm._s(
                                                                                        _vm
                                                                                          .variazioneDiValidazione
                                                                                          .variazioniCorrelate[
                                                                                          rigaCorrelata
                                                                                            .id
                                                                                        ]
                                                                                          .quantitaPerTagliaComunicate[
                                                                                          i
                                                                                        ]
                                                                                      ) +
                                                                                      " "
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _c(
                                                                                "v-text-field",
                                                                                {
                                                                                  staticStyle:
                                                                                    {
                                                                                      margin:
                                                                                        "10px 0 -10px 0",
                                                                                    },
                                                                                  attrs:
                                                                                    {
                                                                                      "background-color":
                                                                                        _vm
                                                                                          .variazioneDiValidazione
                                                                                          .variazioniCorrelate[
                                                                                          rigaCorrelata
                                                                                            .id
                                                                                        ]
                                                                                          .quantitaPerTagliaPreComunicazione[
                                                                                          i
                                                                                        ] !=
                                                                                        _vm
                                                                                          .variazioneDiValidazione
                                                                                          .variazioniCorrelate[
                                                                                          rigaCorrelata
                                                                                            .id
                                                                                        ]
                                                                                          .quantitaPerTagliaComunicate[
                                                                                          i
                                                                                        ]
                                                                                          ? "blue lighten-4"
                                                                                          : "",
                                                                                      type: "number",
                                                                                      min: "0",
                                                                                    },
                                                                                  model:
                                                                                    {
                                                                                      value:
                                                                                        _vm
                                                                                          .variazioneDiValidazione
                                                                                          .variazioniCorrelate[
                                                                                          rigaCorrelata
                                                                                            .id
                                                                                        ]
                                                                                          .quantitaPerTagliaComunicate[
                                                                                          i
                                                                                        ],
                                                                                      callback:
                                                                                        function (
                                                                                          $$v
                                                                                        ) {
                                                                                          _vm.$set(
                                                                                            _vm
                                                                                              .variazioneDiValidazione
                                                                                              .variazioniCorrelate[
                                                                                              rigaCorrelata
                                                                                                .id
                                                                                            ]
                                                                                              .quantitaPerTagliaComunicate,
                                                                                            i,
                                                                                            _vm._n(
                                                                                              $$v
                                                                                            )
                                                                                          )
                                                                                        },
                                                                                      expression:
                                                                                        "variazioneDiValidazione.variazioniCorrelate[rigaCorrelata.id].quantitaPerTagliaComunicate[i]",
                                                                                    },
                                                                                }
                                                                              ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    }
                                                                  ),
                                                                  0
                                                                )
                                                              : _vm
                                                                  .variazioneDiValidazione
                                                                  .variazioniCorrelate[
                                                                  rigaCorrelata
                                                                    .id
                                                                ]
                                                                  .statoValidazione ==
                                                                _vm
                                                                  .StatoVariazione
                                                                  .RigaEliminataDaBC
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "variazione-validazione-eliminata orange lighten-4",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " Eliminazione riga accettata "
                                                                    ),
                                                                    !_vm
                                                                      .variazioneDiValidazione
                                                                      .variazioniCorrelate[
                                                                      rigaCorrelata
                                                                        .id
                                                                    ]._accettata
                                                                      ? _c(
                                                                          "v-btn",
                                                                          {
                                                                            staticClass:
                                                                              "row-button",
                                                                            attrs:
                                                                              {
                                                                                color:
                                                                                  "success",
                                                                                fab: "",
                                                                                "x-small":
                                                                                  "",
                                                                                dark: "",
                                                                                absolute:
                                                                                  "",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.accettaVariazione(
                                                                                    rigaCorrelata
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-icon",
                                                                              [
                                                                                _vm._v(
                                                                                  "mdi-check"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          1
                                                                        )
                                                                      : _vm._e(),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                            _vm
                                                              .variazioneDiValidazione
                                                              .variazioniCorrelate[
                                                              rigaCorrelata.id
                                                            ]
                                                              .statoValidazione !=
                                                            _vm.StatoVariazione
                                                              .RigaEliminataDalFornitore
                                                              ? _c(
                                                                  "div",
                                                                  [
                                                                    !_vm
                                                                      .variazioneDiValidazione
                                                                      .variazioniCorrelate[
                                                                      rigaCorrelata
                                                                        .id
                                                                    ]._accettata
                                                                      ? _c(
                                                                          "v-btn",
                                                                          {
                                                                            staticClass:
                                                                              "row-button",
                                                                            attrs:
                                                                              {
                                                                                color:
                                                                                  "success",
                                                                                fab: "",
                                                                                "x-small":
                                                                                  "",
                                                                                dark: "",
                                                                                absolute:
                                                                                  "",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.accettaVariazione(
                                                                                    rigaCorrelata
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-icon",
                                                                              [
                                                                                _vm._v(
                                                                                  "mdi-check"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          1
                                                                        )
                                                                      : _c(
                                                                          "v-btn",
                                                                          {
                                                                            staticClass:
                                                                              "row-button",
                                                                            attrs:
                                                                              {
                                                                                color:
                                                                                  "orange",
                                                                                fab: "",
                                                                                "x-small":
                                                                                  "",
                                                                                dark: "",
                                                                                absolute:
                                                                                  "",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.annullaVariazione(
                                                                                    rigaCorrelata
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-icon",
                                                                              [
                                                                                _vm._v(
                                                                                  "mdi-undo"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                      ],
                                                      2
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    1
                  )
                : _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c(
                        "v-alert",
                        {
                          staticStyle: { margin: "auto" },
                          attrs: { type: "info", value: true },
                        },
                        [
                          _vm._v(
                            "Non ci sono righe correlate per questo componente."
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }